import { type FC } from 'react';

import { LayoutBlock } from '../LayoutBlock';

import { Card } from './internal/components/Card';
import { MainCard } from './internal/components/MainCard';

import styles from './PikInNumbersV2.css';

type TPikInNumbersV2Props = {
  onView: () => void;
};

export const PikInNumbersV2: FC<TPikInNumbersV2Props> = ({ onView }) => {
  return (
    <LayoutBlock id="pik-in-numbers-v2" title="ПИК в цифрах" onView={onView}>
      <div className={styles['container']} data-testid="pik-in-numbers-v2-cards">
        <MainCard description="в 14 регионах РФ сейчас в реализации ПИК" title=">150 жилых кварталов" />
        <Card
          imageAlt="Женщина отдыхает на крыше жилого дома ПИК с книгой, рядом идёт кот"
          description="жилья уже застроили"
          imageSrc="https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/pik-in-numbers/card-square-meters.webp"
          title="37 млн м²"
        />
        <Card
          imageAlt="Пара с котом переезжает в новую квартиру ПИК с коробками"
          description="семей проживает в кварталах ПИК"
          imageSrc="https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/pik-in-numbers/card-families.webp"
          title=">620 тыс. семей"
        />
        <Card
          imageAlt="Дети играют на детской площадке у жилого комплекса"
          description="школ и детских садиков построено ПИК"
          imageSrc="https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/pik-in-numbers/card-objects.webp"
          title=">170 объектов"
        />
        <Card
          imageAlt="Сотрудник ПИК с планировкой квартиры на мольберте и планшетом"
          description="человек работает над проектами ПИК"
          imageSrc="https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/pik-in-numbers/card-persons-qty.webp"
          title=">30 тысяч"
        />
      </div>
    </LayoutBlock>
  );
};
